import React from 'react';
import { Mail, Phone, ShieldOff } from 'lucide-react';

function ClientAccessDenied() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        {/* Icon */}
        <div className="mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto">
            <ShieldOff className="text-red-600" size={40} />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Accès restreint
        </h1>

        {/* Message */}
        <p className="text-gray-600 mb-6">
          Votre accès à l'espace client a été temporairement désactivé.
          Pour réactiver votre accès, veuillez nous contacter.
        </p>

        {/* Contact Information */}
        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <h2 className="text-lg font-semibold text-blue-900 mb-3">
            Contactez-nous
          </h2>
          
          <div className="space-y-2 text-sm">
            <div className="flex items-center justify-center text-blue-700">
              <Mail className="mr-2" size={16} />
              <span>support@agentime.fr</span>
            </div>
            
            <div className="flex items-center justify-center text-blue-700">
              <Phone className="mr-2" size={16} />
              <span>+33 1 23 45 67 89</span>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="text-xs text-gray-500">
          <p>Nous traiterons votre demande dans les plus brefs délais.</p>
          <p className="mt-1">L'équipe AgenTime</p>
        </div>

        {/* Back to Login Button */}
        <div className="mt-6">
          <a
            href="/client-login"
            className="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Retour à la connexion
          </a>
        </div>
      </div>
    </div>
  );
}

export default ClientAccessDenied;
